<ng-template #progressIndicator>
  <div *ngIf="eventService.isDokumentpaketRequestPending$.getValue()" class="lv-on-load-dokumentpaket-spinner">
    <mat-progress-spinner mode="indeterminate" [diameter]="100"></mat-progress-spinner>
  </div>
</ng-template>
<ng-container *ngIf="dokumenteState$ | async as geladeneDoks; else progressIndicator">

  <!--
<ng-container *ngIf="!downloadVerpflichtend && !!geladeneDoks.length">
<div class="lv-download-button-mit-vorschau" [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
<div class="lv-download-button-mit-vorschau-content" [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <button mat-button (click)="selectToggle()">
    <div class="lv-download-button-mit-vorschau-select-button-content">
      <div>{{'BUTTON_DOWNLOAD.DOKUMENTE_AUSWAEHLEN' | translate}}</div>
      <div>
        <mat-icon color="accent" class="lv-download-button-mit-vorschau-select-button-icon" [svgIcon]="'SquareCheck'"></mat-icon>
      </div>
    </div>
  </button>
</div>
<div class="lv-download-button-mit-vorschau-content" [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <button mat-button (click)="unselectToggle()">
    <div class="lv-download-button-mit-vorschau-select-button-content">
      <div>{{'BUTTON_DOWNLOAD.DOKUMENTE_ABWAEHLEN' | translate}}</div>
      <div>
        <mat-icon class="lv-download-button-mit-vorschau-select-button-icon" [svgIcon]="'Square'"></mat-icon>
      </div>
    </div>
  </button>
</div>
</div>
</ng-container>
<div class="lv-download-button-mit-vorschau" [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
<ng-container *ngFor="let dokument of geladeneDoks">
<lv-dokument-card class="lv-download-button-mit-vorschau-card" [downloadVerpflichtend]="downloadVerpflichtend"
                  [dokument]="dokument"></lv-dokument-card>
</ng-container>
</div>

-->


<div class="lv-document-elemente-alignment" [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-document-element-alignment">
  <lv-dokument-tree-element (treeChanged)="receiveDocumentsFromTree($event)" [downloadVerpflichtend]="downloadVerpflichtend"
                    [dokument]="geladeneDoks"></lv-dokument-tree-element>
  </div>
</div>


  <div *ngIf="!!geladeneDoks.length" class="lv-artefact-container">
    <lv-download-button (successfullyDownloaded)="enableCheckbox()" [uiDokumentliste]="geladeneDoks" [uiArtefakt]="uiArtefakt"
                        [downloadVerpflichtend]="downloadVerpflichtend" class="lv-primary-button"></lv-download-button>
  </div>

  <div *ngIf="!geladeneDoks.length" class="lv-artefact-container">
    {{'BUTTON_DOWNLOAD.DOKUMENTE_NICHT_VERFUEGBAR' | translate}}
  </div>
</ng-container>

<ng-container *ngIf="downloadVerpflichtend">
  <lv-uiartefakt-container [uiArtefakte]="uiArtefakt.UIArtefakt"></lv-uiartefakt-container>
</ng-container>



